/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Arguments for adding a marketplace listing to viewer favorites. */
export type BuyerFavoriteAddInput = {
  /** Address UUID of the listing to favorite. */
  addressId: Types.Scalars['UUID']['input'];
  /** Product surface where the viewer added the favorite. */
  origin: MarketplaceFavoriteOrigin;
};

/** Arguments for removing a marketplace listing from viewer favorites. */
export type BuyerFavoriteRemoveInput = {
  /** Address UUID of the listing to remove from favorites. */
  addressId: Types.Scalars['UUID']['input'];
};

/** Product surface where the viewer added a marketplace favorite. */
export type MarketplaceFavoriteOrigin =
  /** The viewer added the favorite from the marketplace gallery. */
  | 'GALLERY'
  /** The viewer added the favorite from listing details. */
  | 'LISTING_DETAILS';

export type MarketplaceListingFavoriteStateQueryVariables = Exact<{
  addressId: Types.Scalars['UUID']['input'];
}>;


export type MarketplaceListingFavoriteStateQuery = { marketplace: { listing: { isLiked: Types.Scalars['Boolean']['output'] | null } | null } };

export type MarketplaceViewerFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceViewerFavoritesQuery = { customerAccount: { buyer: { favorites: Array<{ addressId: Types.Scalars['UUID']['output'] }> } } };

export type BuyerFavoriteAddMutationVariables = Exact<{
  input: Types.BuyerFavoriteAddInput;
}>;


export type BuyerFavoriteAddMutation = { buyerFavoriteAdd:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export type BuyerFavoriteRemoveMutationVariables = Exact<{
  input: Types.BuyerFavoriteRemoveInput;
}>;


export type BuyerFavoriteRemoveMutation = { buyerFavoriteRemove:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const MarketplaceListingFavoriteStateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceListingFavoriteState($addressId: UUID!) {
  marketplace {
    listing(addressId: $addressId) {
      isLiked
    }
  }
}
    `) as unknown as TypedDocumentString<MarketplaceListingFavoriteStateQuery, MarketplaceListingFavoriteStateQueryVariables>;
export const MarketplaceViewerFavoritesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceViewerFavorites {
  customerAccount {
    buyer {
      favorites {
        addressId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MarketplaceViewerFavoritesQuery, MarketplaceViewerFavoritesQueryVariables>;
export const BuyerFavoriteAddDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BuyerFavoriteAdd($input: BuyerFavoriteAddInput!) {
  buyerFavoriteAdd(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<BuyerFavoriteAddMutation, BuyerFavoriteAddMutationVariables>;
export const BuyerFavoriteRemoveDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BuyerFavoriteRemove($input: BuyerFavoriteRemoveInput!) {
  buyerFavoriteRemove(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<BuyerFavoriteRemoveMutation, BuyerFavoriteRemoveMutationVariables>;